package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CommonResponse(
    val data: String = "",
    val error: String = "",
    val message: String = ""
)
@Serializable
data class CommonNullResponse(
    val data: String ?= "",
    val error: String ? = ""
)

@Serializable
data class CommonSingleResponse(
    val response: String,
)
